import React from "react"
import { Headphones, FlaskConical, Plug } from "lucide-react"
import { useLang } from "./i18n/LangContext"
import { PlaceholderImage } from "./PlaceholderImage"

const ICONS = [Headphones, FlaskConical, Plug]
const VARIANTS = ["helpdesk", "experiments", "integrations"]

export function UpcomingSection() {
  const { t } = useLang()
  const up = t.upcoming

  return (
    <section className="bg-gray-50 dark:bg-gray-900 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center mb-14">
          <span className="inline-block rounded-full bg-amber-100 dark:bg-amber-950 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-amber-700 dark:text-amber-400 mb-4">
            {up.badge}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white text-balance">
            {up.heading}
          </h2>
          <p className="mt-4 text-gray-500 dark:text-gray-400 max-w-xl mx-auto text-pretty">
            {up.subheading}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {up.items.map((item, i) => {
            const Icon = ICONS[i]
            return (
              <div
                key={i}
                className="rounded-2xl bg-white dark:bg-gray-800 p-6 ring-1 ring-gray-200 dark:ring-gray-700"
              >
                <PlaceholderImage variant={VARIANTS[i]} aspect="aspect-video" label={item.imageLabel} className="mb-5" />
                <div className="flex items-start justify-between gap-3 mb-4">
                  <div className="inline-flex items-center justify-center rounded-xl bg-amber-50 dark:bg-amber-950 p-3">
                    <Icon className="h-6 w-6 text-amber-600 dark:text-amber-400" />
                  </div>
                  <span className="inline-block rounded-full bg-amber-50 dark:bg-amber-950 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-widest text-amber-600 dark:text-amber-400">
                    {up.badge}
                  </span>
                </div>
                <p className="text-xs font-semibold uppercase tracking-widest text-amber-600 dark:text-amber-400 mb-1">{item.tagline}</p>
                <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">{item.title}</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">{item.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
